import React, { Component } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';

import { updatePlan as updateAttPlan } from '../../actions/attSubs';
import { updatePlan as updateTracfonePlan } from '../../actions/tracfoneSubs';
import { updatePlan as updateSimoPlan } from '../../actions/simoSubs';
import getCarrier from 'helpers/getCarrier';

export class UpdatePlanButton extends Component {
  state = {
    success: false,
    loading: false,
    error: '',
  };

  handleUpdatePlan = async () => {
    const {
      item,
      updateAttPlan,
      updateTracfonePlan,
      updateSimoPlan,
      findPurchase,
      purchaseId,
    } = this.props;
    const { subscription } = item;

    if (!subscription) {
      return;
    }
    this.setState({ loading: false, success: false, error: '' });

    const carrier = getCarrier(subscription);

    const updatePlanToCarrier = {
      att: updateAttPlan,
      tracfone: updateTracfonePlan,
      simo: updateSimoPlan,
    };
    const updatePlan = updatePlanToCarrier[carrier];

    try {
      const key = `${carrier}_plan`;
      this.setState({ loading: true });
      await updatePlan(subscription.id, {
        plan_id: item[key],
      });
      await findPurchase(purchaseId);
      this.setState({ loading: false, success: true });
    } catch (e) {
      const error = e && e.errors ? JSON.stringify(e.errors) : e.message;
      this.setState({ loading: false, error });
    }
  };

  render() {
    const { success, error, loading } = this.state;
    return (
      <React.Fragment>
        <button
          className={cn('btn', 'btn-default', { 'text-success': success })}
          onClick={this.handleUpdatePlan}
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Update plan'}
        </button>
        {error && (
          <span className="text-warning">
            <br />
            {error}
          </span>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  updateAttPlan,
  updateTracfonePlan,
  updateSimoPlan,
};

export default connect(null, mapDispatchToProps)(UpdatePlanButton);
